import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import store from "app/shared/store/store";
import { instance } from "app/shared/util/token-store";
import {
  DataAutoTopUpCreate,
  FetchAutoTopUpAuthorizationRequest,
  FetchAutoTopUpDeleteRequest,
  FetchAutoTopUpTransactionRequest,
  FetchAutoTopUpValidPhoneRequest,
} from "../reducer/types";

const createParam = (dataCreate?: DataAutoTopUpCreate) => {
  const userProfile = store.getState().account.USERPROFILE;
  const params = {
    cifnumber: userProfile?.CIFNUMBER,
    cifname: userProfile?.FULLNAME, // tên KH
    billno: dataCreate?.INQUIRY_CODE, // số đt
    provider: dataCreate?.PROVIDER?.value, // nhà mạng
    accountno: dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO,
    accounttype: dataCreate?.ACCOUNT_DEBIT?.ACCOUNTTYPE,
    denominations: dataCreate?.AMOUNT, // mệnh giá
    custype: "R", // Loại khách hàng (R: cá nhân ; C: Doanh nghiệp)
    //Ko bắt buộc
    branch: dataCreate?.ACCOUNT_DEBIT?.BRANCH_CODE, // Chi nhánh
    address: userProfile?.ADDRESS, // địa chỉ
    note: dataCreate?.NOTE, // ghi chú
    paynow: dataCreate?.PAYMENT_DATE?.value, //  thanh toán (Y/N)
    paydate: "", // ngày thanh toán
    gender: userProfile?.GENDER, // Giới tính
  };
  return params;
};

const authParam = (action?: FetchAutoTopUpAuthorizationRequest) => {
  const cifNum = store.getState().account.USERPROFILE?.CIFNUMBER;
  const params = {
    cifnumber: cifNum,
    billno: action?.payload?.billno,
    reqid: action?.payload?.transId,
    challengeid: action?.payload?.otptransid,
    otp: action?.code,
  };
  return params;
};

export const fetchAutoTopUpListService = async () => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_LIST);
  const cifNum = store.getState().account.USERPROFILE?.CIFNUMBER;
  const response: any = await instance.get(url + "/" + cifNum);
  return response;
};

export const fetchAutoTopUpDeleteService = async (actionRq?: FetchAutoTopUpDeleteRequest) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_DELETE);
  const cifNum = store.getState().account.USERPROFILE?.CIFNUMBER;
  const body = {
    cifnumber: cifNum,
    billno: actionRq?.payload?.billno,
    accountno: actionRq?.payload?.accountno,
  };
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchAutoTopUpListProviderService = async () => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_LIST_PROVIDER);
  const response: any = await instance.get(url);
  return response;
};

export const fetchAutoTopUpValidPhoneService = async (actionRq?: FetchAutoTopUpValidPhoneRequest) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_VALID_PHONE);
  const validPhone = actionRq?.payload?.INQUIRY_CODE;
  const response: any = await instance.get(url + "/" + validPhone);
  return response;
};

export const fetchAutoTopUpCreateService = async (actionRq?: DataAutoTopUpCreate) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_CREATE);
  const body = createParam(actionRq);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchAutoTopUpAuthService = async (actionRq?: FetchAutoTopUpAuthorizationRequest) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_AUTHORIZE_INFO);
  const body = authParam(actionRq);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchAutoTopUpTransactionService = async (actionRq?: FetchAutoTopUpTransactionRequest) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_AUTO_TOP_UP_TRANSACTION);
  const response: any = await instance.get(url + "/");
  return response;
};
